import CodeMutator from "./CodeMutator";

export class ParsingError extends Error { }

export default class ProgramParser {
    constructor() {
        this.codeBlocks = {}
        this.reloadCodeBlocks()
    }

    reloadCodeBlocks() {
        const requestOptions = {
            method: 'GET',
        };

        fetch('/codeblocks.json', requestOptions).then((response) => response.json()).then((data) => {
            this.codeBlocks = data.codeBlocks
            console.log(this.codeBlocks)

        })
    }

    collectCode(ASTProgram) {
        // collect all code blocks
        let code = {}
        code.includes = []
        code.declarations = []
        code.functions = []
        code.setup = []
        code.loop = []

        for (let i = 0; i < ASTProgram.length; i++) {
            const topLevelNode = ASTProgram[i];
            this.#collectCodeForNode(topLevelNode, code)
        }
        return code
    }

    #insertVariablesInCode(code, ASTNode, considerNext = false) {
        if(ASTNode === undefined){
            console.log(code)
            throw Error("Code not finished")
        }
        console.log(ASTNode)
        console.log(CodeMutator[ASTNode.name])
        if(CodeMutator[ASTNode.name]){
            code = CodeMutator[ASTNode.name](code, ASTNode  )
        }
        const variables = /"""{{.*?}}"""/g.exec(code)

        console.log(variables)
        if (!variables) {
            // if all variables where filled in, check for next block if defined
            if(considerNext && ASTNode.next) {
                ASTNode.next.runCode.forEach(runCode_name => {
                    const runCode = this.codeBlocks[runCode_name]
                    code += "\n" + this.#insertVariablesInCode(runCode, ASTNode.next, considerNext)
                })
            }
            return code
        }
        const variable = variables[0];
        const variable_name = variable.substring(5, variable.length - 5)
        let insertable_code = 0
        if (ASTNode.values[variable_name] !== undefined) {

            let value = ASTNode.values[variable_name]
            insertable_code = this.#insertVariablesInCode(this.codeBlocks[value.runCode[0]], value)

        } else if (ASTNode.statements[variable_name] !== undefined) {
            let statement = ASTNode.statements[variable_name]

            insertable_code = this.#insertVariablesInCode(this.codeBlocks[statement.runCode[0]], statement, true)
        } else if (ASTNode.fields[variable_name] !== undefined) {
            insertable_code = ASTNode.fields[variable_name]
        } else {
            throw new ParsingError(`variable ${variable_name} not found in block`)
        }
        const spaces = this.#getNumberOfSpacesAfterLastLinebreak(code.substring(0, variables.index))
        const newCode = code.substring(0, variables.index) + this.#addSpacesBeforeEachLine(insertable_code, spaces, true) + code.substring(variables.index + variable.length)
        return this.#insertVariablesInCode(newCode, ASTNode, considerNext)

    }

    #getNumberOfSpacesAfterLastLinebreak(code){
        let lastLinebreak = code.lastIndexOf("\n")
        let substring = code.substring(lastLinebreak +1)
        let numberOfSpaces = substring.split(" ").length - 1
        let numberOfTabs = substring.split("\t").length - 1
        return ((numberOfSpaces+numberOfTabs === substring.length ? numberOfSpaces + numberOfTabs*4 : 0))
    }

    #addSpacesBeforeEachLine(code, numberOfSpaces, exceptFirstLine=false){
        let lines = code.split("\n")
        let linesWithSpaces = lines.map((line) => " ".repeat(numberOfSpaces) + line)
        if(exceptFirstLine && linesWithSpaces.length >= 1) {
            linesWithSpaces[0] = lines[0]
        }
        return linesWithSpaces.join("\n")
    }

    #parseRunCode(ASTProgram) {
        const programStartNode = ASTProgram.find(topLevelNode => { return topLevelNode.name === "start" })
        return this.#insertVariablesInCode("", programStartNode, true)
    }

    #doesCodeExist(code_name){
        return this.codeBlocks[code_name] !== undefined
    }

    #collectCodeForNode(ASTNode, c) {
        // generate code from node
        // declaration code
        ASTNode.declarationCode.forEach(code_name => {
            if(!this.#doesCodeExist(code_name)) return 
            const code = this.#insertVariablesInCode(this.codeBlocks[code_name], ASTNode)
            c.declarations.push(code)

        });

        // function code
        ASTNode.functionCode.forEach(code_name => {
            if(!this.#doesCodeExist(code_name)) return 
            const code = this.#insertVariablesInCode(this.codeBlocks[code_name], ASTNode)
            c.functions.push(code)

        });

        // setup code
        ASTNode.setupCode.forEach(code_name => {
            if(!this.#doesCodeExist(code_name)) return 

            const code = this.#insertVariablesInCode(this.codeBlocks[code_name], ASTNode)
            c.setup.push(code)

        });

        // _loop code
        ASTNode.loopCode.forEach(code_name => {
            if(!this.#doesCodeExist(code_name)) return 
            const code = this.#insertVariablesInCode(this.codeBlocks[code_name], ASTNode)
            c.loop.push(code)
        });

        // call function for child nodes and next
        Object.keys(ASTNode.values).forEach(key => {
            this.#collectCodeForNode(ASTNode.values[key], c)
        })
        Object.keys(ASTNode.statements).forEach(key => {
            this.#collectCodeForNode(ASTNode.statements[key], c)
        })

        if (ASTNode.next) {
            this.#collectCodeForNode(ASTNode.next, c)
        }
    }

    #combineCode(code) {
        let combinedCode = {}
        Object.keys(code).forEach(key => {
            combinedCode[key] = ""
            code[key].forEach(code_snippet => {
                combinedCode[key] += code_snippet + "\n"
            })
        })
        return combinedCode
    }

    #insertIntoBaseCode(code) {
        return this.#insertVariablesInCode(this.codeBlocks["baseCode_run"], { "fields": code, "values": {}, "statements": {} })
    }

    #filterDeclarationCode(declaration_code) {
        let new_declaration_code = []
        for (let i = 0; i < declaration_code.length; i++) {
            const code = declaration_code[i];
            let lines = code.split("\n")
            lines.forEach((line) => {
                if(!new_declaration_code.includes(line)) {
                    new_declaration_code.push(line)
                }
            })
            
        }
        return new_declaration_code
    }

    #filterSetupCode(setup_code) {
        let new_setup_code = []
        for (let i = 0; i < setup_code.length; i++) {
            const code = setup_code[i];
            if(!new_setup_code.includes(code)) {
                new_setup_code.push(code)
            }            
        }
        return new_setup_code
    }

    #filterLoopCode(loop_code) {
        let new_loop_code = []
        for (let i = 0; i < loop_code.length; i++) {
            const code = loop_code[i];
            if(!new_loop_code.includes(code)) {
                new_loop_code.push(code)
            }
        }
        return new_loop_code
    }
    #extractFunctions(cCode) {
        // Regex pattern for extracting functions
        const functionRegex = /(\b(?!else)\w+\b (\w+\b)\([^)]+\)[\t\n\r ]+\{)/g;
      
        // Array to store the found functions
        const matches = []
        // save all matches
        let match;
        while((match = functionRegex.exec(cCode)) !== null) {
            matches.push({
                name: match[2],
                index: match.index
            })
        }
        // push content of 
        const functions = [];
        for (let i = 0; i < matches.length; i++) {
            const currentMatch = matches[i];
            let endIndex = undefined
            if(i < matches.length - 1) {
                endIndex = matches[i+1].index
            }
            functions.push({
                name: currentMatch.name,
                code: cCode.slice(currentMatch.index, endIndex)
            })

        }

        return functions;
    }
      
    #filterFunctionCode(function_code) {
        // berücksichtigt keine strings, auf die das theoretisch matchen könnte. 
        // Idee: Auf Parsing umsteigen in der Zukunft?
        let added_function_names = []
        let new_function_code = []
        for (let i = 0; i < function_code.length; i++) {
            const code = function_code[i];
            let functions = this.#extractFunctions(code)
            functions.forEach((funct) => {
                if(!added_function_names.includes(funct.name)){
                    added_function_names.push(funct.name)
                    new_function_code.push(funct.code)
                }
            })
        }
        return new_function_code
    }

    parseProgram(ASTProgram) {
        try{
            let collected_code = this.collectCode(ASTProgram)

            // filter code 
            collected_code.declarations = this.#filterDeclarationCode(collected_code.declarations)
            collected_code.setup = this.#filterSetupCode(collected_code.setup)
            collected_code.loop = this.#filterLoopCode(collected_code.loop)
            collected_code.functions = this.#filterFunctionCode(collected_code.functions)
    
            let combined_code = this.#combineCode(collected_code)
            combined_code.run = this.#parseRunCode(ASTProgram)
    
            let code = this.#insertIntoBaseCode(combined_code)
            console.log(code)
            return code
        } catch(e) {
            console.log(e)
            throw Error("Your program might be incomplete!")
        }
    }
}